import type { MathRun } from '../../../Shared/Pdf/mathRuns.ts';

/** Spanish number-property prompts (ADR 0051 part 3). */
export const numberPropertyPrompts = {
    multiples: (count: number, base: number) => `Escribe los primeros ${count} múltiplos de ${base}.`,
    gcf: (a: number, b: number) => `¿Cuál es el máximo común divisor de ${a} y ${b}?`,
    lcm: (a: number, b: number) => `¿Cuál es el mínimo común múltiplo de ${a} y ${b}?`,
    primeComposite: (value: number) => `¿${value} es primo o compuesto?`,
    evenOdd: (value: number) => `¿${value} es par o impar?`,
    // ADR 0132. The radical is a run, drawn by MathText; the French question mark
    // keeps its no-break space (U+00A0, which WinAnsi has).
    estimatingRoots: (radicand: number): MathRun[] => [
        { text: '¿Entre qué dos números enteros está ' },
        { root: String(radicand) },
        { text: '?' },
    ],
    factors: (value: number) => `Escribe todos los factores de ${value}.`,
};

export const primeCompositeLabels = { prime: 'Primo', composite: 'Compuesto' };
export const evenOddLabels = { even: 'Par', odd: 'Impar' };

/** The key to an estimating question: the two whole numbers a root falls between. */
export const rootPairKey = (lower: number, upper: number) => `${lower} y ${upper}`;
